import { invariant } from '@e-socna/utils';
import { DISPLAY_PATH_TITLE_SEPARATOR } from '@e-socna/printer-contract';

import { pathToChapters } from '../../utils/path-to-chapters.util';

interface Props {
  readonly displayPath?: readonly number[];
  readonly title?: string | null;
  readonly useSeparator: boolean;
}

export const Title = ({
  displayPath,
  title,
  useSeparator,
}: Readonly<Props>) => {
  invariant(
    (!!displayPath || !title) && (!displayPath || !!title),
    'Title component must have both displayPath and title props.',
  );

  if (!displayPath && !title) {
    return null;
  }

  if (displayPath && title) {
    invariant(
      !!displayPath.length,
      'Title component must have a displayPath with at least one element.',
    );

    const titleContent = `${pathToChapters(displayPath)}${
      useSeparator ? DISPLAY_PATH_TITLE_SEPARATOR : ' '
    }${title}`;

    if (displayPath.length === 1) {
      return <h1>{titleContent}</h1>;
    } else if (displayPath.length === 2) {
      return <h2>{titleContent}</h2>;
    } else if (displayPath.length === 3) {
      return <h3>{titleContent}</h3>;
    } else if (displayPath.length === 4) {
      return <h4>{titleContent}</h4>;
    } else if (displayPath.length === 5) {
      return <h5>{titleContent}</h5>;
    } else if (displayPath.length === 6) {
      return <h6>{titleContent}</h6>;
    }

    throw new Error(
      'Title component must have a displayPath with at most 6 elements.',
    );
  }

  return null;
};
